export default "__VITE_ASSET__BvRKSuMS__"